/**
 * Created by r4zi4l on 21.12.2021
 */

const Map2dAdviceDragLogic = function (options) {
    Map2dAdviceBaseLogic.call(this, options);
};

Map2dAdviceDragLogic.prototype = Object.create(Map2dAdviceBaseLogic.prototype);
Map2dAdviceDragLogic.prototype.constructor = Map2dAdviceDragLogic;

Map2dAdviceDragLogic.prototype.findMove = function () {
    const units = Map2d.currentMap.listAvailableUnits();
    const draggables = [];
    let acceptors = [];

    for (let i = 0; i < units.length; ++i) {
        const unit = units[i];

        if (unit.getData().draggable && this.targets.some(Unit.Equals.bind(null, unit))) {
            draggables.push(unit);
            continue;
        }

        if (unit.findAcceptorComponent(this.targets)) {
            acceptors.push(unit);
        }
    }

    acceptors = acceptors.filter((unit) => Map2d.currentMap.isScreenCellPosition(unit.x, unit.y));

    let bestDistance, bestDraggable, bestAcceptor;
    for (let i = 0; i < acceptors.length; ++i) {
        const acceptor = acceptors[i];

        for (let j = 0; j < draggables.length; ++j) {
            const draggable = draggables[j];
            const distance = cc.pDistanceSQ(acceptor, draggable);
            if (distance < 21 && (bestDistance === undefined || distance < bestDistance)) {
                bestDistance = distance;
                bestDraggable = draggable;
                bestAcceptor = acceptor;
            }
        }
    }

    if (bestDistance) {
        return {
            cells: [bestDraggable, bestAcceptor],
            highlight: [bestDraggable, bestAcceptor],
            fingerDrag: [bestDraggable, bestAcceptor],
            arrow: bestDraggable
        };
    }
};
